import shared from '../shared';

function showLoading($button) {
	shared.allowSubmit = false;
	$button.addClass('loading').attr('aria-busy', true);
}

export default showLoading;
